import { getPersistConfig } from '@ms/yammer-data/dist/persistedState';

import type { YammerTeamsState } from '../state/types';

export const persistConfig = getPersistConfig<YammerTeamsState>({
  key: 'teams',
  allowlist: ['ecsConfig', 'ecsExperiments', 'ecsFeatureRollouts'],
});
